import { jwtDecode } from 'jwt-decode';

/** Client display/isolation guard only. The API verifies the JWT signature. */
export function captureSubject(token: string | null, now = Date.now()): string | null {
  if (!token) return null;
  try {
    const claims = jwtDecode<{ sub?: string; exp?: number }>(token);
    return typeof claims.sub === 'string' && claims.sub.length > 0 &&
      typeof claims.exp === 'number' && claims.exp * 1000 > now ? claims.sub : null;
  } catch { return null; }
}
export interface CaptureContext { tenantId: string; actorId: string }
export function validatedCaptureContext(value: unknown, token: string): CaptureContext {
  const ctx = value as Partial<CaptureContext> | null;
  if (!ctx || typeof ctx.tenantId !== 'string' || !ctx.tenantId.trim() ||
    !ctx.actorId || ctx.actorId !== captureSubject(token)) {
    throw new Error('Capture identity could not be verified');
  }
  return { tenantId: ctx.tenantId, actorId: ctx.actorId };
}
export function captureScope(context: CaptureContext, instance: string, event: string): string | undefined {
  return instance && event ? JSON.stringify(['batch-grade-v2', context.tenantId, context.actorId, instance, event]) : undefined;
}
